
export class HeaderTypeSelectDualPickListModel{

  list:Array<any>;
/**
 * @param {?=} list
 */
constructor(list = []) {
    this.list = list;
  }


}

function HeaderTypeSelectDualPickListModel_tsickle_Closure_declarations() {
/** @type {?} */
HeaderTypeSelectDualPickListModel.prototype.list;
}

